import React, { useEffect, useState } from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { useLenis } from '../SmoothScroll/SmoothScroll';
import {
  HiOutlineHome,
  HiOutlineUser,
  HiOutlineCode,
  HiOutlineBriefcase,
  HiOutlineAcademicCap,
  HiOutlineMail
} from 'react-icons/hi';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lenis = useLenis();

  const navLinks = [
    { name: 'Home', path: '/#landing', icon: <HiOutlineHome /> },
    { name: 'About', path: '/#about', icon: <HiOutlineUser /> },
    { name: 'Experience', path: '/#experience', icon: <HiOutlineBriefcase /> },
    { name: 'Projects', path: '/#projects', icon: <HiOutlineCode /> },
    { name: 'Education', path: '/#education', icon: <HiOutlineAcademicCap /> },
    { name: 'Contact', path: '/#contacts', icon: <HiOutlineMail /> }
  ];

  /* Hide navbar on scroll down, show on scroll up */
  useEffect(() => {
    if (!lenis) return undefined;

    let lastScroll = 0;
    const onScroll = (instance) => {
      const current = instance.scroll;
      if (current > 120 && current > lastScroll && !isOpen) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      lastScroll = current;
    };

    lenis.on('scroll', onScroll);
    return () => lenis.off('scroll', onScroll);
  }, [lenis, isOpen]);

  /* Lock scroll when mobile menu is open */
  useEffect(() => {
    if (!lenis) return undefined;
    if (isOpen) lenis.stop();
    else lenis.start();
    return () => lenis.start();
  }, [isOpen, lenis]);

  const scrollToSection = (el) => {
    if (!lenis) return;
    lenis.scrollTo(el, {
      offset: -80,
      duration: 1.2,
      easing: (t) => 1 - Math.pow(1 - t, 4),
    });
  };

  const closeMenu = () => setIsOpen(false);

  return (
    <>
      <header className={`site-header ${hidden ? 'header-hidden' : ''}`}>
        <nav className="site-nav-bar" aria-label="Primary">
          <NavLink to="/#landing" className="brand-lockup" onClick={closeMenu} scroll={scrollToSection}>
            <span className="brand-mark" aria-hidden="true"><span /></span>
            <span className="brand-word">
              <span>AKSHAY</span>
              <span>GOSAVI</span>
            </span>
          </NavLink>

          <div className="desktop-links">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                smooth
                scroll={scrollToSection}
                className="desktop-link-item"
              >
                {link.name}
              </NavLink>
            ))}
          </div>

          <NavLink
            to="/#contacts"
            smooth
            scroll={scrollToSection}
            className="ticket-pill"
          >
            <span>Get in touch</span>
            <span className="ticket-arrow" aria-hidden="true">→</span>
          </NavLink>

          <button
            className={`nav-toggle ${isOpen ? 'open' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
            aria-expanded={isOpen}
            type="button"
          >
            <span />
            <span />
          </button>
        </nav>
      </header>

      <div
        className={`nav-overlay ${isOpen ? 'active' : ''}`}
        data-lenis-prevent
        aria-hidden={!isOpen}
      >
        <div className="nav-overlay-inner">
          {navLinks.map((link, idx) => (
            <NavLink
              key={link.name}
              to={link.path}
              smooth
              scroll={(el) => {
                closeMenu();
                scrollToSection(el);
              }}
              tabIndex={isOpen ? 0 : -1}
              className="overlay-link"
              style={{
                transitionDelay: isOpen ? `${0.1 + idx * 0.05}s` : '0s',
              }}
            >
              <span className="link-num">0{idx + 1}</span>
              <span>{link.name}</span>
              <span className="link-icon">{link.icon}</span>
            </NavLink>
          ))}

          <NavLink
            to="/#contacts"
            smooth
            scroll={(el) => {
              closeMenu();
              scrollToSection(el);
            }}
            tabIndex={isOpen ? 0 : -1}
            className="overlay-cta"
            style={{ transitionDelay: isOpen ? '0.45s' : '0s' }}
          >
            Get in touch →
          </NavLink>
        </div>
      </div>
    </>
  );
}

export default Navbar;
